export default "__VITE_ASSET__BYguxPrw__"